// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunnerOptionalParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { xngCheckSubscription } from "@rc/App/Services/JoinToday/joinTodayService";

export interface CheckSubscriptionModel {
    successful: boolean;
    errorMessage: any;
    Response?: boolean;
}

type HandlerType = ApiHandler<HasOnSuccess & HasOnError, CheckSubscriptionModel>;

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await xngCheckSubscription();
        props.apiResult.successful = true;
    } catch (error) {
        props.apiResult = {
            errorMessage: error?.errorJson?.description,
            successful: false,
            Response: props.apiResult.Response,
        };
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult as any);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const chain = [RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const checkSubscription = createHandlerChainRunnerOptionalParameter(chain, {}, "checkSubscription");
export default checkSubscription;
